import { WorkspaceTemplate } from "@/types/workspace"

export const applyUserFilter = (ownerId: string, list: WorkspaceTemplate[]) => {
  return list.filter(workspace => workspace.userId === ownerId)
}
